import { OrdersFilters } from "../../orders";
import { Currency, MonthlyStats, OrdersStat, ReportClientInformationDto } from "../types";
import { getFilterOutputCurrency, sumMonthlyStats } from "../utils";
import { useGroupMonthlyStats } from "./useGroupMonthlyStats";

export interface OrdersReportData {
    filters: OrdersFilters;
    currencyFilter: string;
    outputCurrency: string;
    monthsInOrder: number[];
    clientInformationByClientCode: Record<string, ReportClientInformationDto>;
    clientCodes: string[];
    monthlyOrdersByClientCode: Record<string, MonthlyStats>;
    totalMonthlyOrders: MonthlyStats;
    previousPeriodStartDate: Date;
    currentPeriodEndDate: Date;
}

export const useOrdersReportData = (
    ordersStat: OrdersStat | undefined,
    filters: OrdersFilters,
    monthsInOrder: number[],
    previousPeriodStartDate: Date,
    currentPeriodEndDate: Date,
) => {
    const outputCurrency = getFilterOutputCurrency(filters.currency);

    const {
        monthlyStatsByGroupId: monthlyStatsByClientCode,
        groupsId: monthlyStatsGroupsId,
        isProcessing,
    } = useGroupMonthlyStats(ordersStat?.ordersByClientCode || [], outputCurrency);

    const allMonthlyStats = Object.values(monthlyStatsByClientCode);
    const totalMonthlyOrders: MonthlyStats = sumMonthlyStats(allMonthlyStats);

    const ordersReportData: OrdersReportData = {
        filters: filters,
        currencyFilter: filters.currency || Currency.CanadianDollar,
        outputCurrency: getFilterOutputCurrency(filters.currency),
        clientInformationByClientCode: ordersStat?.clientInformationByClientCode || {},
        clientCodes: monthlyStatsGroupsId as string[],
        monthlyOrdersByClientCode: monthlyStatsByClientCode,
        monthsInOrder: monthsInOrder,
        totalMonthlyOrders,
        currentPeriodEndDate,
        previousPeriodStartDate,
    };

    return { ordersReportData, isProcessing };
};
